<script>
import {dictMixin} from "@/mixins";
import {momentFormat} from "@/utils/util";
import {expert, expert_file} from "@/api/projectReviewService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender.vue";
import FileUpload from "@/components/form/upload/FileUpload.vue";
import ImgUpload from "@/components/form/upload/ImgUpload";

const zjkcy = require('@/assets/img/zjkcy.png')
const rzcg = require('@/assets/img/rztg.png')

const sfz = require('@/assets/svg/dataShow.png')
const sqb = require('@/assets/svg/申请表.png')
const zczs = require('@/assets/svg/职称证书.png')
export default {
    name: "Detail",
    components: {FileUpload, DictRender,ImgUpload},
    mixins:[dictMixin],
    data(){
        return {
            zjkcy,
            rzcg,
            sfz,
            sqb,
            zczs,
            detail:{},
            download: file_service.download,
            dictNames: 'sex,title_level,ethnic_group,education_background,politicalOutlook,unit_category,major_domain,file_category',
            titleFileData: [],
            titleFileColumns: [
                {title: '职称/职（执）业资格名称', dataIndex: 'fileName', key: 'fileName', slots: {customRender: 'title',}},
                // {title: '职称/职(执)资格等级', dataIndex: 'fileLevel', key: 'fileLevel', slots: {customRender: 'fileLevel',}},
                {title: '职称/职(执)资格附件', dataIndex: 'filePath', key: 'filePath', slots: {customRender: 'filePath',}},
                // {title: '操作', dataIndex: 'action', key: 'action', slots: {customRender: 'action'}, width:'120px'},
            ],
            otherFileData: [],
            otherFileColumns: [
                // {title: '证书名称', dataIndex: 'fileName', slots: {customRender: 'fileName',}},
                {title: '证书类型', dataIndex: 'fileCategory', slots: {customRender: 'fileCategory',}},
                {title: '证书附件', dataIndex: 'filePath', slots: {customRender: 'filePath',}},
                // {title: '操作', dataIndex: 'action', slots: {customRender: 'action'}, width:'120px'},
            ]
        }
    },
    created() {
        this.getExpertInfo()
    },
    computed:{
        idCardPath(){
            return this.download+this.detail.idCardFile
        }
    },
    methods: {
        momentFormat,
        getExpertInfo() {
            this.getAction({
                url: expert.current
            }).then(res => {
                res.professionDomain = res.professionDomain.split(",")
                this.detail = {...res}
                this.getOtherFile()
                this.getTitleFile()
            })
        },
        onPreviewFile(file){
            const link = document.createElement("a"); // 创建a标签
            link.href = this.download+file;
            link.target = '_blank';
            link.click();
        },
        getTitleFile(){
            this.getAction({
                url: expert_file.getTitleByExpert,
                params:{expertId: this.detail.id}
            }).then(resp=>{
                this.titleFileData = resp
            })
        },
        getOtherFile(){
            this.getAction({
                url: expert_file.getOtherByExpert,
                params:{expertId: this.detail.id}
            }).then(resp=>{
                this.otherFileData = resp
            })
        },
    }
}
</script>

<template>
    <a-card>
        <a-descriptions :column="6" size="middle" bordered :labelStyle="{ width: '140px'}">
            <a-descriptions-item label="姓名" :span="3">
                {{detail.name}}
            </a-descriptions-item>
            <a-descriptions-item label="手机号码" :span="3">
                {{detail.phoneNumber}}
            </a-descriptions-item>
            <a-descriptions-item label="聘用证书" :span="3">
                <ImgUpload v-if="detail.appointmentFile" ref="upload" modalWidth="850px" modalTitle="聘书预览"
                           v-model:value="detail.appointmentFile" :disabled="true"
                           :show-btn="false"></ImgUpload>
                <div class="value"
                     style="width: 104px;height: 104px;color:#666;background: #fafafa;border: 1px dashed #d9d9d9;border-radius: 4px;text-align: center;line-height: 104px;"
                     v-else>
                    暂无
                </div>
            </a-descriptions-item>

            <a-descriptions-item :span="3" label="个人签名">
                <ImgUpload v-if="detail.signatureFile" v-model:value="detail.signatureFile" disabled :count="1" modal-title="签名预览"></ImgUpload>
                <div v-else>未上传</div>
            </a-descriptions-item>

            <a-descriptions-item :span="3" label="聘书发放时间">{{ detail.appointmentTime?.substr(0,10) }}</a-descriptions-item>

            <a-descriptions-item  :span="3" label="银行账号">{{ detail.bankAccount }}</a-descriptions-item>
            <a-descriptions-item  :span="3" label="银行名称">{{ detail.bankName }}</a-descriptions-item>
            <a-descriptions-item  :span="3" label="行号">{{ detail.bankNo }}</a-descriptions-item>

            <a-descriptions-item label="身份证号" :span="3">
                {{ detail.idCard }}
            </a-descriptions-item>
            <a-descriptions-item label="出生年月" :span="3">
                {{ momentFormat(new Date(detail.birthday))}}
            </a-descriptions-item>
            <a-descriptions-item label="性别" :span="3">
                <dict-render :text="detail.sex" :dict-obj="dictObjs['sex']"/>
            </a-descriptions-item>
            <a-descriptions-item label="民族" :span="3">
                <dict-render :text="detail.nation" :dict-obj="dictObjs['ethnic_group']"/>
            </a-descriptions-item>
            <a-descriptions-item label="政治面貌" :span="3">
                <dict-render :text="detail.political" :dict-obj="dictObjs['politicalOutlook']"/>
            </a-descriptions-item>
            <a-descriptions-item label="电子邮箱" :span="3">
                {{ detail.email }}
            </a-descriptions-item>
            <a-descriptions-item label="最高学历" :span="3">
                <dict-render :text="detail.highestDegree" :dict-obj="dictObjs['education_background']"/>
            </a-descriptions-item>
            <a-descriptions-item label="参加工作时间" :span="3">
                {{ momentFormat(new Date(detail.beginWorkDate))}}
            </a-descriptions-item>
            <a-descriptions-item label="毕业院校" :span="3">
                {{ detail.collage }}
            </a-descriptions-item>
            <a-descriptions-item label="专业" :span="3">
                {{ detail.major }}
            </a-descriptions-item>
            <a-descriptions-item label="居住地址" :span="3">
                {{ detail.addressDetail }}
            </a-descriptions-item>
            <a-descriptions-item label="工作单位" :span="3">
                {{ detail.workUnit }}
            </a-descriptions-item>
            <a-descriptions-item label="职务" :span="3">
                {{ detail.position }}
            </a-descriptions-item>
            <a-descriptions-item label="单位类别" :span="3">
                <dict-render :text="detail.unitCategory" :dict-obj="dictObjs['unit_category']"/>
            </a-descriptions-item>
<!--            <a-descriptions-item label="职称/职(执)资格证书名称" :span="3">
                {{ detail.positional }}
            </a-descriptions-item>
            <a-descriptions-item label="职称/职(执)资格等级" :span="3">
                <dict-render :text="detail.positionalLevel" :dict-obj="dictObjs['title_level']"/>
            </a-descriptions-item>-->
            <a-descriptions-item label="擅长专业领域" :span="6">
                <dict-render :text="detail.professionDomain" :dict-obj="dictObjs['major_domain']"/>
            </a-descriptions-item>
            <a-descriptions-item label="工作经历" :span="6">
                {{ detail.workExperience }}
            </a-descriptions-item>
            <a-descriptions-item label="主要研究成果及突出贡献" :span="6">
                {{ detail.researchResult }}
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="身份证">
                <a href="#" @click="onPreviewFile(detail.idCardFile)" target="_blank"><img :src="sfz" alt=""><span style="margin-left: 8px">身份证</span></a>
            </a-descriptions-item>
            <a-descriptions-item :span="3" label="专家库成员申请表">
                <a href="#" @click="onPreviewFile(detail.applyFile)" target="_blank"><img :src="sqb" alt=""><span style="margin-left: 8px">专家库成员申请表</span></a>
            </a-descriptions-item>
            <a-descriptions-item :span="6" label="职称/职(执)资格证书">
<!--                <file-upload v-model:value="detail.positionalFile" :showBtn="false" disabled/>-->
                <a-table :columns="titleFileColumns" :data-source="titleFileData" :pagination="false">
<!--                    <template #fileLevel="{record}">
                        <dict-render :text="record.fileLevel" :dict-obj="dictObjs['title_level']"/>
                    </template>-->

                    <template #filePath="{record}">
                        <file-upload v-model:value="record.filePath" disabled/>
                    </template>

                    <template #action="{record}">
                        <a-button type="danger" size="small" @click="onDelFile(record.id)">删除</a-button>
                    </template>
                </a-table>
            </a-descriptions-item>
            <a-descriptions-item :span="6" label="其他证书资料">
<!--                <file-upload v-model:value="detail.credentials" :showBtn="false" disabled/>-->
                <a-table :columns="otherFileColumns" :data-source="otherFileData" :pagination="false">
                    <template #fileCategory="{record}">
                        <dict-render :text="record.fileCategory" :dict-obj="dictObjs['file_category']"/>
                    </template>

                    <template #filePath="{record}">
                        <file-upload v-model:value="record.filePath" disabled/>
                    </template>

                    <template #action="{record}">
                        <a-button type="danger" @click="onDelFile(record.id)">删除</a-button>
                    </template>
                </a-table>
            </a-descriptions-item>
        </a-descriptions>
    </a-card>
</template>

<style scoped lang="less">

</style>
